
















































import Vue from 'vue';
import Component, { mixins } from 'vue-class-component';
import ResizeUpdateMixin from '@/common/ts/resizing/ResizeUpdateMixin';
import Icon from '@/webcomponents/brandhub-icon/Icon.vue';
import ChildComponentMixin from '@/common/ts/child-component/ChildComponentMixin';

const AccordionItemProps = Vue.extend({
  props: {
    title: String,
    text: {
      type: String,
      default: '',
    },
    collapsed: {
      type: Boolean,
    },
    options: {
      type: String,
      default: 'variant-12',
    },
  },
});

@Component({
  components: {
    'accordion-icon': Icon,
  },
})
export default class AccordionItem extends mixins(AccordionItemProps, ChildComponentMixin, ResizeUpdateMixin) {
  $refs!: {
    content: HTMLElement;
  }

  open = false;
  height = 0;
  isBlock = false;

  created () {
    this.initChildComponentMixin(
      'AccordionItem',
    );
  }

  mounted () {
    if (!this.collapsed) {
      this.openContent();
    }
  }

  openContent () {
    this.open = !this.open;
    const event = new CustomEvent('accordionItemClicked', {
      bubbles: true,
      composed: true,
      detail: {
        clickedItem: this,
      },
    });
    this.$el.dispatchEvent(event);
    if (this.$refs.content && this.open) {
      this.isBlock = true;
      this.$nextTick(() => {
        if (this.$refs.content) {
          this.height = this.$refs.content.scrollHeight;
          this.isBlock = false;
        }
      });
    }
  }

  get rootStyle () {
    return {
      '--content-height': `${this.height}px`,
    };
  }

  get contentClass () {
    return {
      'brandhub-accordion-item__content--variant-4-8': this.options === 'variant-4-8',
      'brandhub-accordion-item__content--variant-8-4': this.options === 'variant-8-4',
      'brandhub-accordion-item__content--variant-12': this.options === 'variant-12',
    };
  }

  get displayStyle () {
    if (this.isBlock) {
      return { '--content-display': 'block' };
    }
    return { '--content-display': 'flex' };
  }

  get arrowClass () {
    return {
      'brandhub-accordion-item__icon--opened': this.open,
      'brandhub-accordion-item__icon--closed': !this.open,
    };
  }
}

